module.exports = __webpack_public_path__ + "img/1285982034.3d78c620.jpg";